export const hotelViewType = {
  oceanFront: "オーシャンフロント",
  oceanView: "オーシャンビュー",
  partialOceanView: "パーシャルオーシャンビュー",
  nothing: "なし",
};
